export const SET_TITHES = 'SET_TITHES';
export const SET_TITHE = 'SET_TITHE';
export const ADD_TITHE = 'ADD_TITHE';
export const UPDATE_TITHE = 'UPDATE_TITHE';
export const REMOVE_TITHE = 'REMOVE_TITHE';
export const CLEAR_TITHE = 'CLEAR_TITHE';
export const CLEAR_TITHES = 'CLEAR_TITHES';
